<template>
  <div class="step step_last"  :class="{'form__step_hidden': step != number}" :aria-labelledby="`step${number}-title`">
    <h3 class="form__title">Согласие на обработку персональных данных*</h3>
    <CheckboxInput v-model="stepsdata[number][names[0]]" :name="names[0]" descr="Я ознакомился с Пользовательским соглашением, политикой обработки персональных данных (ПД) и даю согласие на обработку ПД*" />
    <h3 class="form__title">Подтвердите, что Вы не робот*</h3>
    <div id="captcha-container" class="smart-captcha" data-sitekey="D5EbUa8ujnEQDrRS2lt7b5GRBnHRNromvC9U7DF4" style="height: 100px; box-sizing: content-box; ">
    </div>
    <div class="form__btns">
      <Btn class="btn_gray" @click.native.prevent="$store.commit('prevStep')">Назад</Btn>
      <Btn @click.native.prevent="$store.dispatch('sendForm')" :disabled="!filled() || step != number">Отправить</Btn>
    </div>
  </div>
</template>

<script>
import Btn from './ui/Btn.vue'
import { mapState } from 'vuex'
import CheckboxInput from './CheckboxInput.vue'
export default {
  data: ()=>({
    names: ['agreementpersonaldataprocessing'],
    mountcount: -1
  }),
  components: { Btn, CheckboxInput },
  props: {
    number: {type: Number, default: 14}
  },
  mounted(){
    this.mountcount++
    if (this.mountcount) 
      return console.error('lastStep mounted twice')
    window.onloadFunction = this.verify.bind(this)
    let script = document.createElement('script')
    script.setAttribute('src',"https://captcha-api.yandex.ru/captcha.js?render=onload&onload=onloadFunction")
    script.setAttribute('defer', '')
    document.body.appendChild(script)
  },
  methods: {
    expired(){
      this.$store.commit('setCaptcha', false)
      setTimeout(()=>this.$refs.captcha.reset(), 1000)
    },
    verify(){
      if (window.smartCaptcha) {
        const container = document.getElementById('captcha-container');

        const widgetId = window.smartCaptcha.render(container, {
          sitekey: 'D5EbUa8ujnEQDrRS2lt7b5GRBnHRNromvC9U7DF4',
          hl: 'ru',
        })
        window.smartCaptcha.subscribe( widgetId,'success',
          () => {
            const response = window.smartCaptcha.getResponse(widgetId)
            if (!response)
              return console.error('Ответ капчи - пустой')
            this.$store.commit('setCaptcha', true)
            this.stepsdata[this.number]['g-recaptcha-response'] = response
          })
      }
    },
    filled(){
      return this.captchaPassed && this.stepsdata[this.number][this.names[0]]
    }
  },
  computed: {
    ...mapState(['stepsdata','step','captchaPassed']),
  }

}
</script>

<style lang="sass">
</style>